export const isFulfilled = action => {
    return `${action}_FULFILLED`;
};

export const isRejected = action => {
    return `${action}_REJECTED`;
};

export const isPending = action => {
    return `${action}_PENDING`;
};
